var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "fieldset",
    { staticClass: "custom-fieldset" },
    [
      _c("legend", [_vm._v("Nocleg nr " + _vm._s(_vm.partIndex + 1))]),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { staticClass: "pa-1", attrs: { md: "3", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  rules: [_vm.isRequired],
                  label: "Nazwa hotelu*",
                  readonly: _vm.$store.state.AdminTravelService.isOfferReadonly
                },
                model: {
                  value: _vm.contextPart.name,
                  callback: function($$v) {
                    _vm.$set(_vm.contextPart, "name", $$v)
                  },
                  expression: "contextPart.name"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pa-1", attrs: { md: "3", cols: "12" } },
            [
              _c("v-rating", {
                staticClass: "small-rating",
                attrs: {
                  rules: [_vm.isRequired],
                  readonly: _vm.$store.state.AdminTravelService.isOfferReadonly
                },
                model: {
                  value: _vm.contextPart.hotel_class,
                  callback: function($$v) {
                    _vm.$set(_vm.contextPart, "hotel_class", $$v)
                  },
                  expression: "contextPart.hotel_class"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pa-1", attrs: { md: "6", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  rules: [_vm.isRequired],
                  label: "Adres*",
                  readonly: _vm.$store.state.AdminTravelService.isOfferReadonly
                },
                model: {
                  value: _vm.contextPart.address,
                  callback: function($$v) {
                    _vm.$set(_vm.contextPart, "address", $$v)
                  },
                  expression: "contextPart.address"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pa-1", attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  rules: [_vm.isRequired],
                  label: "Termin zakwaterowania*",
                  readonly: _vm.$store.state.AdminTravelService.isOfferReadonly
                },
                model: {
                  value: _vm.contextPart.start_date,
                  callback: function($$v) {
                    _vm.$set(_vm.contextPart, "start_date", $$v)
                  },
                  expression: "contextPart.start_date"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pa-1", attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  rules: [_vm.isRequired],
                  label: "Termin wykwaterowania*",
                  readonly: _vm.$store.state.AdminTravelService.isOfferReadonly
                },
                model: {
                  value: _vm.contextPart.end_date,
                  callback: function($$v) {
                    _vm.$set(_vm.contextPart, "end_date", $$v)
                  },
                  expression: "contextPart.end_date"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pa-1", attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  rules: [_vm.isRequired],
                  label: "Liczba osób w pokoju*",
                  readonly: _vm.$store.state.AdminTravelService.isOfferReadonly
                },
                model: {
                  value: _vm.contextPart.person_per_room,
                  callback: function($$v) {
                    _vm.$set(_vm.contextPart, "person_per_room", $$v)
                  },
                  expression: "contextPart.person_per_room"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pa-1", attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  rules: [_vm.isRequired],
                  label: "Liczba pokoi*",
                  readonly: _vm.$store.state.AdminTravelService.isOfferReadonly
                },
                model: {
                  value: _vm.contextPart.rooms,
                  callback: function($$v) {
                    _vm.$set(_vm.contextPart, "rooms", $$v)
                  },
                  expression: "contextPart.rooms"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pa-1", attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  rules: [_vm.isRequired],
                  label: "Typ pokoju*",
                  readonly: _vm.$store.state.AdminTravelService.isOfferReadonly
                },
                model: {
                  value: _vm.contextPart.room_type,
                  callback: function($$v) {
                    _vm.$set(_vm.contextPart, "room_type", $$v)
                  },
                  expression: "contextPart.room_type"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pa-1", attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Dodatkowe usługi",
                  readonly: _vm.$store.state.AdminTravelService.isOfferReadonly
                },
                model: {
                  value: _vm.contextPart.additional_services,
                  callback: function($$v) {
                    _vm.$set(_vm.contextPart, "additional_services", $$v)
                  },
                  expression: "contextPart.additional_services"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pa-1", attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Średnia kwota za dobę",
                  readonly: _vm.$store.state.AdminTravelService.isOfferReadonly
                },
                model: {
                  value: _vm.contextPart.price_per_day,
                  callback: function($$v) {
                    _vm.$set(_vm.contextPart, "price_per_day", $$v)
                  },
                  expression: "contextPart.price_per_day"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pa-1", attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Termin bezkosztowej anulacji",
                  placeholder: "Oferta bezzwrotna",
                  readonly: _vm.$store.state.AdminTravelService.isOfferReadonly
                },
                model: {
                  value: _vm.contextPart.cancel_until,
                  callback: function($$v) {
                    _vm.$set(_vm.contextPart, "cancel_until", $$v)
                  },
                  expression: "contextPart.cancel_until"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pa-1", attrs: { cols: "12" } },
            [
              _c("v-textarea", {
                attrs: {
                  label: "Komentarz",
                  readonly: _vm.$store.state.AdminTravelService.isOfferReadonly
                },
                model: {
                  value: _vm.contextPart.comment,
                  callback: function($$v) {
                    _vm.$set(_vm.contextPart, "comment", $$v)
                  },
                  expression: "contextPart.comment"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }